<template>
  <w-dialog :dialog-show="state" @handleClose="handleClose">
    <div class="continue-content flex-column-center" slot="content" @touchmove.prevent>
      <img src="https://files.wondercv.com/mobile/cvs/become-member.png" alt="">
      <span class="iconfont iconx" @click="handleClose" />
      <div class="continue-footer" @click="buyMember"></div>
    </div>
  </w-dialog>
</template>

<script>
import WDialog from '@/components/global/w-dialog'
import { envMixin } from '@/assets/js/mixin/global'

export default {
  name: 'member-dialog',
  mixins: [envMixin],
  props: {
    state: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  mounted () {
  },
  computed: {},
  watch: {},
  components: {
    WDialog
  },
  methods: {
    handleClose () {
      this.$emit('handleClose')
    },
    buyMember () {
      this.$fn.jump(
        `/pages/member-buy/index`,
        () => {
          this.$router.push(`/buy/member/order`)
        }
      )
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/global/variable';
.continue-content {
  position: relative;
  img {
    width: 80vw;
    margin-bottom: 35px;
  }
  .iconx {
    font-size: 48px;
    font-weight: bold;
    color: $color-light;
  }
  .continue-footer {
    width: 80vw;
    height: 90px;
    background: transparent;
    position: absolute;
    bottom: 82px;
  }
}
</style>
